import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { URL_IMAGES_BANKS } from 'apps/promo/constants/UrlConstants';
import { resolveArguments } from 'apps/promo/helpers/utils';

import AnimatedBanksNew from './AnimatedBanksNew';
import { BankItem, BanksList } from './styles';

const BanksSection = (props) => {
    if (!props.banksList) {
        return <></>;
    }

    const banksArray = props.banksList;
    const condBanksAnimated = banksArray.length > 5;

    const renderStaticBanks = (banksArray) => {
        const renderBanks = banksArray.map((bank, index) => {
            return (
                <BankItem key={`${bank}${index}`}>
                    <figure>
                        <img height="64" width="64" alt={bank} src={`${URL_IMAGES_BANKS}/${bank}.png`} />
                    </figure>
                </BankItem>
            );
        });
        return <BanksList>{renderBanks}</BanksList>;
    };

    const title = resolveArguments(props.bankSectionTitle, props.countryName);

    return (
        !props.isShowSpinner && (
            <>
                <HeadingSection title={title} text={props.bankSectionSubtitle} noBottomIndent />
                {condBanksAnimated ? <AnimatedBanksNew data={banksArray} /> : renderStaticBanks(banksArray)}
            </>
        )
    );
};
const mapStateToProps = (state) => {
    return {
        isShowSpinner: state.app.isShowSpinner,
        banksList: state.extra?.strapiApi?.calculator?.banksList,
        countryName: state.extra?.strapiApi?.calculator?.messages?.countryName,
        bankSectionTitle: state.extra?.strapiApi?.headlineBankSection?.title,
        bankSectionSubtitle: state.extra?.strapiApi?.headlineBankSection?.text,
    };
};
BanksSection.propTypes = {
    title: PropTypes.string,
    isShowSpinner: PropTypes.bool,
};

export default connect(mapStateToProps)(BanksSection);
